import { render, staticRenderFns } from "./InvoiceSummary.vue?vue&type=template&id=95d850ac&scoped=true&"
import script from "./InvoiceSummary.vue?vue&type=script&lang=js&"
export * from "./InvoiceSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d850ac",
  null
  
)

export default component.exports